module.exports = __webpack_public_path__ + "static/media/vortex-drobilci-s.8a2701ab.webp";